<div class="history-layout">
  <div class="history-cards">
    <div class="current-version-card">
      <div class="card-text">
        <div class="overline text-onsurfacevar">Current version</div>
        <div class="file-type-contenar">
          <div class="icon">
            <sync-icon [name]="iconName" iconSize="default"></sync-icon>
          </div>
          <div class="subtitle subtitle-1 wrap-text">
            {{ currentItem?.name || '...' }}
          </div>
        </div>
      </div>
      <div class="card-button">
        <sync-button
          [type]="'outlined'"
          [label]="'View file'"
          [disabled]="false"
          [isLoading]="false"
          [leadAdornment]="false"
          [trailAdornment]="false"
          [onClick]="onViewButtonClick"
          [disabled]="!isFileViewable"
        ></sync-button>
      </div>
    </div>
    <div class="version-duration-card" *ngIf="limit && planName">
      <div class="card-text">
        <div class="overline text-onsurfacevar">Access to history</div>
        <div class="subtitle subtitle-1">{{ limit }} days ({{ planName }})</div>
        <div class="expiry-warning">
          <div><sync-icon [name]="'warning'" iconSize="small"></sync-icon></div>
          <div class="caption text-onsurfacevar">
            Versions older than {{ limit }} days will be deleted
          </div>
        </div>
      </div>
        <app-upgrade-plan-button class="card-button"></app-upgrade-plan-button>
      
    </div>
  </div>
  <div class="history-list" *ngIf="versionHistoryDataSource?.[0]?.action_text !== 'Deleted'">
    <sync-data-list
      class="responsive-list"
      [idColumnKey]="'hist_id'"
      [isSelectable]="false"
      [showListFilterOption]="false"
      [showBulkActions]="false"
      [data]="versionHistoryDataSource"
      [columns]="dataListColumns"
      [listViewBreakpoint]="$any(0)"
      [isLoading]="isLoading"
      [countText]="''">
    </sync-data-list>

    <div class="no-more-data" *ngIf="!hasMore">
      <span class="body body-2 text-onsurfacevar">No more versions to load</span>
    </div>
    <!-- <sync-pagination *ngIf="versionHistoryDataSource.length > 10" alignment="right" #syncPagination
      [length]="versionHistoryDataSource.length+hasNextPage"
      [onPageChange]="versionHistoryPaginationConfig.onPageChange">
  </sync-pagination> -->
  <div class="load-more" *ngIf="hasMore && versionHistoryDataSource.length > 49 ">
    <sync-button
        type="outlined"
        [isLoading]="isLoadMoreLoading"
        label="Load more..."
        (click)="getHistory()"
    ></sync-button>
</div>
  </div>

  <div class="history-empty-container" *ngIf="versionHistoryDataSource.length && versionHistoryDataSource[0]?.action_text === 'Deleted'">
    <div class="history-empty-content">
      <div class="h3 empty-heading">This file has been deleted</div>
      <div class="body-1 empty-text">Restore your file to manage its version history.</div>
    </div>
    <sync-button   
      [type]="'filled'"
      [label]="'Restore file'"
      [disabled]="false"
      [isLoading]="false"
      [leadAdornment]="true"
      [leadIconAdornment]="'restore'"
      [onClick]="onRestoreClick"
    ></sync-button>
  </div>
</div>
<ng-template #itemRef let-data="data">
  <div class="event-item body-body-2">
    {{ currentItem.name }}
  </div>
</ng-template>

<ng-template #avatarItemRef let-data="data">
  <sync-avatar
  [url]="this.fileListService.getAvatarUrl(data.event_user_id)"
  [initials]="data.event_username"
></sync-avatar>
</ng-template>

<div class="history-preview-dialog">
  <sync-dialog [config]="dialogConfig" [open]="showDialog" [onClose]="onCancelDialogClick" [hideDialogFooter]="false" [isFullScreen]="isSmallScreen">
      <div class="history-preview-container" *ngIf="showDialog && !['image'].includes(type)" [ngClass]="'history-preview-container-type-'+type">
          <app-preview [isViewInDialog]="true" [type]="type" [locId]="syncId" [item]="previewOldItem" [ngClass]="'type-'+type"></app-preview>
      </div>
        <div class="history-preview-dialog-container" *ngIf="showDialog && ['image'].includes(type)">
          <app-preview-dialog [type]="type" [locId]="syncId" [item]="previewOldItem" ></app-preview-dialog>
        </div>
  </sync-dialog>
</div>

<!-- <div class="history-preview-dialog-">
  <sync-dialog [config]="dialogConfig" [open]="showDialog" [onClose]="onCancelDialogClick" [hideDialogFooter]="false" [isFullScreen]="isSmallScreen">
      <div class="history-preview-container-box" *ngIf="showDialog">
          <ng-container  [ngTemplateOutlet]="previewRef"  [ngTemplateOutletContext]="{ type, syncId, previewOldItem }"></ng-container>
      </div>
  </sync-dialog>
</div> -->

<div class="restore-dialog">
  <sync-dialog [config]="{
      title: 'Restore',
      subTitle: subTitle,
      isClosable: false,
      actionButton: 'Restore',
      cancelButton: 'Cancel',
      onCancelClick: closeDialog,
      onActionClick: onRestoreDialogClick
    }" [open]="showRestoreDialog" [hideDialogFooter]="false">
      <div class="body-1 restore-body-text">Confirm you want to restore 1 item(s) from Sync.</div>
  </sync-dialog>
</div>
<ng-template #nameTemplate let-data="data">
  <div class="wrap-inner-text">
    {{ currentItem.name || "-" }}
  </div>
</ng-template>